document.addEventListener('DOMContentLoaded', async () => {
    const scrollBarBoxEl = document.querySelectorAll('.jsScrollBar');
    if (scrollBarBoxEl.length > 0) {
        const { renderScrollBar } = await import('./components/scrollbar.js');
        renderScrollBar(scrollBarBoxEl);
    }

    const selectEl = document.querySelectorAll('.jsSelect');
    if (selectEl.length > 0) {
        const { renderSelect } = await import('./components/select.js');
        renderSelect(selectEl);
    }
    const expandBtnEls = document.querySelectorAll('.jsExpandBtn');
    const rankExpandBtnEls = document.querySelectorAll('.jsRankExpandBtn');
    if (expandBtnEls.length > 0 || rankExpandBtnEls.length > 0) {
        const { renderExpand, renderRankExpand } = await import('./components/expand.js');
        if (expandBtnEls.length > 0) {
            renderExpand(expandBtnEls);
        }
        if (rankExpandBtnEls.length > 0) {
            renderRankExpand(rankExpandBtnEls);
        }
    }
});
